
try {

    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = jQuery = require('jquery');

    require('bootstrap');
    require('select2');
    require('./lib/schmodal');


} catch (e) {
    console.log('Error bootstrapping application', e);
}
